import 'ui-core/widgets/show-recommended/js/show-recommended';

const showRecommended = UX.showRecommended;
UX.showRecommended.getContent = widget => {
    let $widget = $(widget);
    $widget.load($widget.attr('data-ajaxurl'), 'onload=true', function () {
        showRecommended.truncate && showRecommended.truncate($widget);
        setTimeout(() => {
            $widget.children().length && $(document).trigger('showRecommended:loaded');
            showRecommended.checkIfClosed($widget);
            showRecommended.hideSkeletons($widget);
        }, 10);
    });
};
